import React, { createContext, useContext } from 'react';
import {
  useAdminPendingDeposits,
  useAdminPendingWithdrawals,
  useAdminPendingKYC,
  useAdminActiveTrades,
  useAdminUsersStats,
  useAdminActivityFeed,
  useAdminDashboardMetrics
} from '../hooks/useAdminRealtime';

const AdminRealtimeContext = createContext();

export const useAdminRealtime = () => {
  const context = useContext(AdminRealtimeContext);
  if (!context) {
    throw new Error('useAdminRealtime must be used within AdminRealtimeProvider');
  }
  return context;
};

export const AdminRealtimeProvider = ({ children }) => {
  // Real-time admin hooks
  const pendingDepositsData = useAdminPendingDeposits();
  const pendingWithdrawalsData = useAdminPendingWithdrawals();
  const pendingKYCData = useAdminPendingKYC();
  const activeTradesData = useAdminActiveTrades();
  const usersStatsData = useAdminUsersStats();
  const activityFeedData = useAdminActivityFeed(20);
  const dashboardMetricsData = useAdminDashboardMetrics();

  const value = {
    // Pending Deposits
    pendingDeposits: pendingDepositsData.pendingDeposits,
    pendingDepositsCount: pendingDepositsData.count,
    pendingDepositsLoading: pendingDepositsData.loading,
    
    // Pending Withdrawals
    pendingWithdrawals: pendingWithdrawalsData.pendingWithdrawals,
    pendingWithdrawalsCount: pendingWithdrawalsData.count,
    pendingWithdrawalsLoading: pendingWithdrawalsData.loading,
    
    // Pending KYC
    pendingKYC: pendingKYCData.pendingKYC,
    pendingKYCCount: pendingKYCData.count,
    pendingKYCLoading: pendingKYCData.loading,
    
    // Active Trades
    activeTrades: activeTradesData.activeTrades,
    activeTradesCount: activeTradesData.count,
    activeTradesLoading: activeTradesData.loading,
    
    // Users Stats
    totalUsers: usersStatsData.totalUsers,
    activeUsers: usersStatsData.activeUsers,
    usersStatsLoading: usersStatsData.loading,
    
    // Activity Feed
    activityFeed: activityFeedData.activities,
    activityFeedLoading: activityFeedData.loading,
    
    // Dashboard Metrics
    dashboardMetrics: dashboardMetricsData.metrics,
    dashboardMetricsLoading: dashboardMetricsData.loading
  };

  return (
    <AdminRealtimeContext.Provider value={value}>
      {children}
    </AdminRealtimeContext.Provider>
  );
};
